<template>
  <div class="h-screen overflow-scroll">
    <div v-for="qrCode in props.qrCodes" :key="qrCode.id">
      <div class="flex">
        <img :src="qrCode.image_url" class="w-48 h-48" />
        <div class="flex flex-col">
          <span>{{ qrCode.space ? "Assigned" : "Unassigned" }}</span>
          <span>
            <a
              class="text-blue-600"
              :target="_blank"
              :href="route('messenger.redirect', [qrCode])"
              >Open</a
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import route from "ziggy-js";

const props = defineProps({
  qrCodes: Array,
});
</script>
